import { frontendURL } from '../../../helper/URLHelper';

const LlamadasView = () => import('./LlamadasView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/llamadas'),
      name: 'llamadas_view',
      component: LlamadasView,
      meta: {
        permissions: ['administrator', 'module_llamadas'],
        requiredCapability: 'call_center_analytics',
      },
    },
  ],
};
